import { categoryTypeLanding } from '../../../constants/ecommerce/landings/enum-category'

export const UPDATE_AVISO_ASOCIADO_A_COMPRA = 'UPDATE_AVISO_ASOCIADO_A_COMPRA'
export const UPDATE_CV_ASOCIADO_A_COMPRA = 'UPDATE_CV_ASOCIADO_A_COMPRA'
export const RESET_AVISO_ASOCIADO_A_COMPRA = 'RESET_AVISO_ASOCIADO_A_COMPRA'
export const RESET_CV_ASOCIADO_A_COMPRA = 'RESET_CV_ASOCIADO_A_COMPRA'
export const RESET_DATA_ASOCIADO_A_COMPRA = 'RESET_DATA_ASOCIADO_A_COMPRA'

export interface AvisoTransaction {
  action: categoryTypeLanding
  avisoId: number
  isJobi: boolean
  typeAviso: string
  prevPage: string
  codigoCupon: string | null
}

export interface BusquedaEnBaseTransaction {
  cvId: number
}

export interface DataByConsumoCreditoCompra {
  avisoTransaction: AvisoTransaction | null
  cvTransaction: BusquedaEnBaseTransaction | null
}

export interface UpdateCvAsociadoCompra {
  type: typeof UPDATE_CV_ASOCIADO_A_COMPRA
  payload: BusquedaEnBaseTransaction
}
export interface UpdateAvisoAsociadoCompra {
  type: typeof UPDATE_AVISO_ASOCIADO_A_COMPRA
  payload: AvisoTransaction
}

export interface ResetAvisoAsociadoCompra {
  type: typeof RESET_AVISO_ASOCIADO_A_COMPRA
  payload: null
}

export interface ResetCvAsociadoCompra {
  type: typeof RESET_CV_ASOCIADO_A_COMPRA
  payload: null
}

export interface ResetAllData {
  type: typeof RESET_DATA_ASOCIADO_A_COMPRA
  payload: null
}
export interface DataByConsumoCreditoCompraState {
  avisoTransaction: AvisoTransaction | null
  cvTransaction: BusquedaEnBaseTransaction | null
}

export const InitialState: DataByConsumoCreditoCompraState = {
  avisoTransaction: null,
  cvTransaction: null,
}

export type DataByConsumoCreditoCompraActions =
  | UpdateAvisoAsociadoCompra
  | UpdateCvAsociadoCompra
  | ResetCvAsociadoCompra
  | ResetAvisoAsociadoCompra
  | ResetAllData
